import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const createShipMobilePage = async (data) => {
  try {
    let res = await Api.post("/ship-cms-mobile-pages", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const duplicateShipMobilePage = async (data) => {
  try {
    let res = await Api.post("/ship-cms-mobile-pages/duplicate-pages", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const bulkShipMobilePage = async (data) => {
  try {
    let res = await Api.post("/ship-cms-mobile-pages/bulk-pages", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const bulkValShipMobilePage = async (data) => {
  try {
    let res = await Api.post("/ship-cms-mobile-pages/bulk-mobile-pages", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getShipMobilePage = async (query) => {
  try {
    let res = await Api.get("/ship-cms-mobile-pages", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const getShips = async (query) => {
  try {
    let res = await Api.get("/menu-list", {
      params: query,
    });
    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};
export const getAllShipMobilePage = async (query) => {
  try {
    let res = await Api.get("/ship-cms-mobile-pages/all", {
      params: query,
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const exportShipMobilePage = async (query) => {
  try {
    let res = await Api.get("/ship-cms-mobile-pages/export", {
      responseType: "arraybuffer",
    });

    return res?.data || [];
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deleteShipMobilePage = async (id) => {
  try {
    let res = await Api.delete("/ship-cms-mobile-pages/" + id);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const updateShipMobilePage = async (id, data) => {
  try {
    let res = await Api.patch("/ship-cms-mobile-pages/" + id, data);

    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Update" };
  }
};
export const updatePosition = async (banners, query) => {
  try {
    let res = await Api.patch(
      "/ship-cms-mobile-pages/relocate-position",
      banners,
      {
        params: query,
      }
    );

    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
};
export const getShipMobilePageByID = async (query) => {
  try {
    let res = await Api.get("/ship-cms-mobile-pages/ids", {
      params: query,
    });
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to Get" };
  }
};
export const updatePageComponents = async (data) => {
  try {
    let res = await Api.post("/page-components", data);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const deletePageComponents = async (id) => {
  try {
    let res = await Api.delete("/page-components/" + id);
    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};

export const fidelioPackages = async (packageId) => {
  try {
    let res = await Api.get(
      `/ship-cms-mobile-pages/fidelio-packages/${packageId}`
    );

    return res?.data;
  } catch (e) {
    return { error: "Something Wrong" };
  }
};


export const checkPackagePages= async(source_package_id, target_package_id)=>{
  try {
    let res = await Api.get(
      `/sailing-page/check-package-pages/${source_package_id}/${target_package_id}`
    ) 
    return res?.data
  } catch (error) {
    return {error :"Something Wrong"}
  }
}